export const layerNameToApiTable = {
  // INFORMAÇÕES GERAIS - RESTO NO MAPSERVER
  "Blocos de Entrega": "info_bloco_entrega",
  
  // ANDAMENTOS DOS PRODUTOS
  "Recobrimento Aerofotogramétrico": "ctrl_aerofotogrametrico",
  "Apoio de Campo - Classe II - PCL": "ctrl_apoio_de_campo_2_pcl",
  "Apoio de Campo - Classe II - HV e PCA": "ctrl_apoio_de_campo_2_hv_pca",
  "Fotoíndice": "ctrl_fotoindice",
  "Perfilamento a LASER Aerotransportado": "ctrl_laser",
  "Classificação da Nuvem De Pontos": "ctrl_class_nuvem_de_pontos",
  "Modelo Digital de Superficie - MDS": "ctrl_mds",
  "Modelo Digital de Terreno - MDT": "ctrl_mdt",
  "Imagem Hipsométrica Composta": "ctrl_img_hipsometrica",
  "Imagem de Intensidade": "ctrl_img_intensidade",
  "Aerotriangulação": "ctrl_aerotriangulacao",
  "Ortofotomosaico RGB/NIR": "ctrl_ortofotomosaico",
  "Curvas de Nível": "ctrl_curva_de_nivel",
  "Base Hidrográfica": "ctrl_base_hidrografica",
  "Base Hidrográfica Ottocodificada": "ctrl_base_hidrografica_ottocodificada",
  "Restituição Planimétrica": "ctrl_restituicao_planimetrica",
  "Reambulação": "ctrl_reambulacao",
  "Edição Gráfica": "ctrl_edicao",

};